import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { EasyEatHqService } from '../common/services/ee-hq.service';

@Injectable({
  providedIn: 'root',
})
export class TableRouteGuard implements CanActivate {
  constructor(private _router: Router, private hqService: EasyEatHqService) {}

  canActivate(): boolean {
    let isUserPermitted =
      !!((JSON.parse(localStorage.getItem('restaurant_settings')) || {})[
        'global'
      ] || {})['table_layout'] && !this.hqService.isHqUser();
    if (isUserPermitted) {
      return true;
    } else {
      this._router.navigate(['']);
      return false;
    }
  }
}
